import { Grid, Breadcrumbs, Link, Typography, Zoom } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { DatePickerTextFiled } from "./TextField";

import {
  startDateChanged,
  endDateChanged,
  allowToSearch,
} from "../redux/General/clientSideSearchActionCreators";
import Store from "../redux/Store";
import { useWindowDimensions } from "./MediaQuery";
import React, { useMemo, useState } from "react";
import { clearSearch } from "../redux/General/generalActions";
const HeaderRouter = (props) => {
  const {
    location: { pathname },
    history,
  } = props;
  const [show_time_selection, set_show_time_selection] = useState(true);

  const pathnames = pathname.split("/").filter((x) => x);
  const { width } = useWindowDimensions();
  const fRouteTitle = routerLinks.find((item, index) => {
    return item.link === pathnames[pathnames.length - pathnames.length];
  });

  useMemo(() => {
    let is_hide_time_textfield = hide_time_selection_list.some((route) => {
      return pathname.includes(route);
    });

    if (is_hide_time_textfield) {
      set_show_time_selection(false);
    } else {
      set_show_time_selection(true);
    }
  }, [pathname]);

  React.useEffect(() => {
    return () => {
      clearSearch();
    };
    // eslint-disable-next-line
  }, [pathname]);
  return (
    <Grid
      container
      item
      xs={12}
      justifyContent="space-between"
      style={{ marginBottom: 16, marginTop: width < 650 ? 16 : 0 }}
    >
      <Grid
        container
        item
        xs={12}
        sm={6}
        alignItems="flex-start"
        direction="column"
        justifyContent="flex-start"
      >
        <Typography variant="h6">
          {fRouteTitle !== undefined ? fRouteTitle.title : "پیشخوان"}
        </Typography>
        <Breadcrumbs aria-label="breadcrumb">
          {pathnames.map((name, index) => {
            const RouteTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const route = routerLinks.find((item) => item.link === name);
            const isLast = index === pathnames.length - 1;

            return isLast || index === 0 ? (
              <Typography key={index} variant="body1">
                {route !== undefined ? route.subTitle : name}
              </Typography>
            ) : (
              <Link
                style={{ cursor: "pointer" }}
                key={index}
                onClick={() => {
                  history.push(RouteTo);
                }}
              >
                {route !== undefined ? route.subTitle : name}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Grid>
      <Zoom in={show_time_selection}>
        <Grid
          item
          container
          justifyContent="space-between"
          direction="row"
          alignItems="flex-end"
          sm={12}
          md={5}
          xs={12}
          lg={5}
          xl={4}
        >
          <Grid item>
            <Typography variant="subtitle2">از تاریخ</Typography>
            <DatePickerTextFiled
              changeHandler={searchChangeHandler}
              action={startDateChanged}
              defaultValue={""}
            />
          </Grid>
          <Grid item>
            <Typography variant="subtitle2">تا تاریخ</Typography>
            <DatePickerTextFiled
              changeHandler={searchChangeHandler}
              action={endDateChanged}
              defaultValue={new Date().toJSON()}
            />
          </Grid>
        </Grid>
      </Zoom>
    </Grid>
  );
};
let hide_time_selection_list = ["personal-info", "newOrders", "readyToSend"];
export default withRouter(HeaderRouter);

const routerLinks = [
  { title: "پیشخوان", subTitle: "پیشخوان", link: "" },
  { title: "سفارش ها", subTitle: "سفارش ها", link: "orders" },
  { subTitle: "سفارش های جدید", title: "سفارش های جدید", link: "newOrders" },
  {
    subTitle: "برگشت از تحویل",
    title: "برگشت از تحویل",
    link: "rejected_delivery",
  },
  { subTitle: "آماده ارسال", title: "آماده ارسال", link: "readyToSend" },
  { subTitle: "تاریخچه", link: "history", title: "تاریخچه" },
  {
    title: "مدیریت کارمندها",
    subTitle: "مدیریت سیستم",
    link: "system-manegment",
  },
  { subTitle: "فهرست کارمندها", title: "مدیریت کارمند ها", link: "employees" },
  {
    subTitle: "دسترسی ها",
    title: "مدیریت گروه کاربران",
    link: "accessibilities",
  },
  { subTitle: "کارمند جدید", title: "کارمند جدید", link: "newEmployeeForm" },
  { subTitle: "کارمند جدید", title: "کارمند جدید", link: "newEmployeeShow" },
  {
    subTitle: "مدیریت گروه کاربران",
    title: "مدیریت گروه کاربران",
    link: "users-group",
  },
  {
    subTitle: "گروه کاربران جدید",
    title: "گروه کاربران جدید",
    link: "new-group",
  },
  {
    subTitle: "مدیر",
    title: "",
    link: "manager",
  },
  {
    subTitle: "کارمند",
    title: "",
    link: "employee",
  },
  {
    subTitle: "تراکنش ها",
    title: "مالی",
    link: "transactions",
  },
  {
    subTitle: "پروفایل من",
    title: "پروفایل من",
    link: "profile",
  },
  {
    subTitle: "مشخصات فردی",
    title: "مشخصات فردی",
    link: "personal-info",
  },
  {
    subTitle: "مشخصات دفتر",
    title: "مشخصات دفتر",
    link: "office-info",
  },
];

const searchChangeHandler = (value, action) => {
  Store.dispatch(action(value)); 
  Store.dispatch(allowToSearch(true));
};
